import { render } from "./OcAttachView.vue?vue&type=template&id=4c96a81a&scoped=true"
import script from "./OcAttachView.vue?vue&type=script&lang=js"
export * from "./OcAttachView.vue?vue&type=script&lang=js"

import "./OcAttachView.vue?vue&type=style&index=0&id=4c96a81a&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c96a81a"]])

export default __exports__